// extracted by mini-css-extract-plugin
export default {"container":"Wpp_container__sEJMF","whatsappIcon":"Wpp_whatsappIcon__QHy2b","whatsappIcon2":"Wpp_whatsappIcon2__mEwVd"};